<template>
  <div>
    <!-- header-->
    <headertop></headertop>

    <div class="main">
      <div class="title">
        <h1 class="left"><i class="el-icon-notebook-2"></i> 笔记详情</h1>
      </div>
      <p class="nodevideo">{{note.video}}</p>

      <!-- 表格 -->
      <el-table :data="note.list.slice((note.currentPage-1)*note.pageSize,note.currentPage*note.pageSize)"
        style="width: 90%;margin: 0 5%;">
        <el-table-column label="时间" sortable prop="time">
        </el-table-column>
        <el-table-column label="内容" sortable prop="content">
        </el-table-column>
        <el-table-column align="right">
          <template slot="header" slot-scope="scope">
            <el-input v-model.trim="note.search" prefix-icon="el-icon-search" size="small" placeholder="输入关键字搜索" />
          </template>
          <template slot-scope="scope">
            <el-button size="mini" @click="note_edit(scope.$index, scope.row)" icon="el-icon-edit" >编辑</el-button>
            <el-popconfirm
              confirm-button-text='确定'
              cancel-button-text='取消'
              icon="el-icon-info"
              icon-color="red"
              title="删除之后不可恢复,是否确认删除？"
              @confirm="note_del(scope.$index, scope.row)"
            >
              <el-button size="mini" type="danger" slot="reference" icon="el-icon-delete">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页-->
      <div class="block center">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="note.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="note.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="note.total">
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="编辑"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
       <el-input type="textarea" v-model.trim="edit.content"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="note_up()">确 定</el-button>
      </span>
    </el-dialog>



    <!-- footer -->
    <footerbom></footerbom>
  </div>
</template>

<script>
  import Header from '../../../../components/index/public/visitor_NavHeader.vue';
  import Footer from '../../../../components/index/public/NavFooter.vue';
  export default {
    data() {
      return {
        note:{
          list:[],
          currentPage: 1, // 当前页码
          total: 0, // 总条数
          pageSize: 10,
          search: '',
          video:''
        },
        dialogVisible: false,
        edit:{
          num:'',
          content:'',
        }
      }
    },
    components: {
      headertop: Header,
      footerbom: Footer
    },
    mounted:function(){
      this.get_list()
    },
    methods: {
      get_list(){
        let _this=this;
        _this.axios.get('/v2/user/get_note_list',{params:{num:_this.$route.query.num,type:_this.$route.query.type}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.note.list=res.data.data.list
              _this.note.total=res.data.data.list.length
              _this.note.video=res.data.data.video
            }else{
              _this.$message.error(res.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      note_edit(index, row) {
        let _this=this
        _this.edit.num=row.num
        _this.get_info(row.num)
      },
      get_info(num){
        let _this=this
        _this.axios.get('/v2/user/get_note_info',{params:{num:num}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.edit.content=res.data.data
              _this.dialogVisible=true
            }else{
              _this.$message.error(res.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      handleClose(done) {
        let _this=this
        _this.$confirm('未保存，确认退出？').then(_ => {
          done();
        })
        .catch(_ => {});
      },
      note_up(){
        let _this=this
        _this.axios.post('/v2/user/note_up',{data:_this.edit}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.dialogVisible=false
              _this.get_list()
            }else{
              _this.$message.error(res.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      note_del(index, row) {
        let _this=this
        _this.axios.post('/v2/user/note_del',{data:row.num}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.get_list()
            }else{
              _this.$message.error(res.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      handleSizeChange(val) {
        this.note.currentPage = 1;
        this.note.pageSize = val;
      },
      handleCurrentChange(val) {
        this.note.currentPage = val;
      },
    },

  }
</script>

<style scoped>
  .header_div {
    z-index: 9999;
  }

  .main {
    min-height: calc(100vh - 330px);
    width: 70%;
    padding: 20px;
    margin: 0 15%;
    z-index: 100;
    background-color: white;
  }

  .title {
    padding: 20px;
    overflow: hidden;
  }

  .nodevideo{
    width: 90%;margin: 20px 5%;
  }

  h1 {
    margin: 0;
  }

  /* 分页 */
  .block {
    margin: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/visitor/Mine/Node/Minenodedetail.vue